export default "__VITE_ASSET__DwcIFI9r__"